import config from 'config';
import React, { useEffect, useState } from 'react'
import prodDoc from "../images/productDoc.svg"
import contact from "../images/contactUs.svg"
import headset from "../images/contact.svg"
import mail from "../images/mail.svg"
import copy from "../images/copy.svg"
import tick from "../images/tick.svg"

const Help = () => {
  const [version, setversion] = useState();
  const [mailCopied,setmailCopied] = useState(false);
  const [phoneCopied,setPhoneCopied] = useState(false);


  useEffect(() => {
    // console.log(config);
  }, [])

  const copyToClipboard=(val)=>{
    navigator.clipboard.writeText(val).then(() => {
      setmailCopied(true);
      // alert('Email address copied to clipboard');
      setTimeout(()=>{
        setmailCopied(false);
      },2000)
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  const copyToClipboardPhone=(val)=>{
    navigator.clipboard.writeText(val).then(() => {
      setPhoneCopied(true);
      // alert('Email address copied to clipboard');
      setTimeout(()=>{
        setPhoneCopied(false);
      },2000)
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  const redirectToVersion=(e)=>{
    if(e.target.value=="V2"){
      window.location.href=`${config.RootUrl}/modules/academicplanning/#/`;
    }
    else if(e.target.value=="V3"){
      window.location.href=`${config.RootUrl}/moduleversions/academicplanning/V1/#/`;

    }
  }
  return (
    <div className='subContainers workspace-current-modal-mode' style={{ padding: "14px 14px 20px" }}>
      <p style={{ fontSize: "14px", fontWeight: "bold" }}>Help</p>
      {/* <select className='form-control py-0 mt-2'
        style={{ backgroundColor: "#F4F5F5", fontSize: "13px" }}
        onChange={(e)=>redirectToVersion(e)}
      >
        <option value="">Select version</option>
        <option value="V2">Academic Planning V2</option>
        <option value="V3">Academic Planning V3</option>

      </select> */}

      <div className='mt-2 pl-2 ws-app-theme-color-20 ws-placeholder-search-text-color' style={{ display: "flex", alignItems: "baseline", gap: "2px", borderRadius: "3px", border: "1px solid #dddddd" }}>
        <div style={{ width: "20px" }}>
          <img src={prodDoc} style={{ width: "100%" }} />
        </div>
        <a style={{ fontSize: "13px",padding: "5px",textDecoration:'none',color:'inherit' }} href={`${config.RootUrl}/modules/helpdesk/#/help/productDocumentation`} target="_blank" rel="noopener noreferrer">Product Documentation</a>
      </div>

      <div className='mt-2 pl-2 ws-app-theme-color-20 ws-placeholder-search-text-color' style={{ display: "flex", alignItems: "baseline", gap: "2px", borderRadius: "3px", border: "1px solid #dddddd" }}>
        <div style={{ width: "20px" }}>
          <img src={headset} style={{ width: "100%" }} />
        </div>
        <p style={{ fontSize: "13px", padding: "5px" }} >Contact Details</p>
      </div>
      <div className='pr-1 pt-1 pl-2 ws-app-theme-color-20 ws-placeholder-search-text-color' style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", border: "1px solid #dddddd",borderBottom:"none",borderTop:"none" }}>
        <div style={{ display: "flex", gap: "2px", alignItems: "baseline" }}>
          <div style={{ width: "20px" }}>
            <img src={mail} style={{ width: "100%" }} />
          </div>
          <p style={{ fontSize: "13px", padding: "5px" }} >Info@vmedulife.com</p>

        </div>

        <div style={{ width: "15px", cursor: "pointer" }} onClick={()=>copyToClipboard("Info@vmedulife.com")}>
          <img src={mailCopied?tick:copy} style={{ width: "100%" }} />
        </div>
      </div>

      <div className='pr-1 pt-1 pl-2 ws-app-theme-color-20 ws-placeholder-search-text-color' style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", border: "1px solid #dddddd",borderTop:"none" }}>
        <div style={{ display: "flex", gap: "2px", alignItems: "baseline" }}>
          <div style={{ width: "20px" }}>
            <img src={contact} style={{ width: "100%" }} />
          </div>
          <p style={{ fontSize: "13px", padding: "5px" }} >+91 83907 01133</p>

        </div>

        <div style={{ width: "15px", cursor: "pointer" }} onClick={()=>copyToClipboardPhone("+91 83907 01133")}>
          <img src={phoneCopied?tick:copy} style={{ width: "100%" }} />
        </div>
      </div>

    </div>
  )
}

export default Help